import PropTypes from "prop-types"
import styled from "@emotion/styled"
import Button from "components/Buttons/Button"
import Link from "components/Link"

const MyButton = styled(Button)`
  white-space: nowrap;
  display: block;
  font-size: 18px;
  line-height: 22px;

  // &:hover {
  //   border: 1px;
  // }
  ${({ isScrolled, hasScroll, theme, isHovered }) => {
    if (!hasScroll || isHovered) {
      return ""
    }
    const isSticky = isScrolled
    return `
      background: ${!isSticky ? theme.palette.common.white : "transparent"};
      border: 2px solid ${theme.palette.primary.main};
      transition:
        color 0.3s ease,
        background-color 0.3s ease,
        border-color 0.3s ease;
    `
  }}

  ${({ theme }) => theme.breakpoints.down("xl")} {
    max-width: 156px;
    width: 100%;
    margin: 0 auto;
    position: fixed;
    bottom: 40px;
    z-index: 1000;
    align-self: center;
    padding: 18px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    padding: 10px 25px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    padding: 10px 25px;
  }
`

const HeaderButton = ({ title, link, isScrolled, hasScroll, isHovered }) => (
  <MyButton
    as={Link}
    to={link}
    variant="outlined"
    isScrolled={isScrolled}
    isHovered={isHovered}
    hasScroll={hasScroll}
  >
    {title}
  </MyButton>
)

HeaderButton.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  isScrolled: PropTypes.bool,
  hasScroll: PropTypes.bool,
  isHovered: PropTypes.bool,
}

HeaderButton.defaultProps = {
  isScrolled: false,
  hasScroll: false,
  isHovered: false,
}

export default HeaderButton
